export default __webpack_public_path__ + "SolutionFormationImages6.e182ebe.png";